import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CapabilityResponseDataSchema, InstallCapabilityBodySchema } from "schema"
import z from "zod"
import { capabilitiesQuery } from "../lib/capabilitiesQuery"
import { marketplaceCapabilitiesQuery } from "../lib/marketplaceCapabilitiesQuery"

type Response = {
  data: z.infer<typeof CapabilityResponseDataSchema>
}

export function useInstallCapabilityMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.input<typeof InstallCapabilityBodySchema>) => {
      const response = await axios.post<Response>("/capabilities", data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: capabilitiesQuery().queryKey })
      queryClient.invalidateQueries({ queryKey: marketplaceCapabilitiesQuery().queryKey })
    },
  })
}
